<script lang="ts">
  import qs from 'qs'

  export let oidc_issuer = 'process.env.OIDC_ISSUER'
  export let oidc_client_id = 'process.env.OIDC_CLIENT_ID'
  export let oidc_redirect_uri = 'process.env.OIDC_REDIRECT_URI'
  export let oidc_post_logout_redirect = 'process.env.OIDC_POST_LOGOUT_REDIRECT'

  const parsed = qs.parse(window.location.search, { ignoreQueryPrefix: true })
</script>

<hdc-support-widget
  data-test="hdc-support-widget"
  memberid={parsed.memberid || ''}
  accountid={parsed.accountid || ''}
  email={parsed.email || ''}
  {oidc_issuer}
  {oidc_client_id}
  {oidc_redirect_uri}
  {oidc_post_logout_redirect}></hdc-support-widget>
